export const review = {
  review: '/admin/review'
  // HTTP METHOD : GET
  // PARAMETERS :
};

export const admin = {
  logout: '/admin/logout',
  // HTTP METHOD : POST
  // PARAMETERS : AdminDto, HttpServletResponse,
  changePassword: '/admin/change-password',
  // HTTP METHOD : PATCH
  // PARAMETERS : AdminChangePasswordRequest,
  login: '/admin/login',
  // HTTP METHOD : PATCH
  // PARAMETERS : AdminLoginRequest, HttpServletResponse,
  dashboard: '/admin/dashboard',
};

export const common = {
  lambda$toMultiValueMap$1: '/common',
  // HTTP METHOD :
  // PARAMETERS : MultiValueMap, String, String,
  lambda$restRequest$0: '/common',
  // HTTP METHOD :
  // PARAMETERS : UriComponentsBuilder, String, String,
  refreshAccessToken: '/common/refresh/access-token',
  // HTTP METHOD : GET
  // PARAMETERS : RefreshAccessTokenDto, HttpServletResponse,
  getEnumValue: '/common/enum',
  // HTTP METHOD : GET
  // PARAMETERS :
  restRequest: '/common/rest',
  // HTTP METHOD : GET
  // PARAMETERS : RestRequestDto,
  versionCheck: '/common/version-check',
  // HTTP METHOD : GET
  // PARAMETERS : UserDeviceDto,
  toMultiValueMap: '/common',
  // HTTP METHOD :
  // PARAMETERS : Map,
  download: '/common/download',
  // HTTP METHOD : GET
  // PARAMETERS : String, String,
  email: '/common/email',
  // HTTP METHOD : GET
  // PARAMETERS :
  sendPush: '/common/sendPush',
  // HTTP METHOD : GET
  // PARAMETERS :
  uploadSingleMultipartFile: '/common/upload',
  // HTTP METHOD : POST
  // PARAMETERS : MultipartFile,
  uploadMultipartFile: '/common/upload/multi'
  // HTTP METHOD : POST
  // PARAMETERS : MultipartFile;,
};

export const board = {
  upsertBoard: '/admin/board',
  boards: '/admin/board',
  boardDetail: '/admin/board/',
  deleteBoard: '/admin/board/',
  updateStatus: '/admin/board/status',
  xl: '/admin/board/xl'
};

export const country = {
  upsertCountry: '/admin/country',
  countries: '/admin/country',
  deleteCountry: '/admin/country/',
  xl: '/admin/country/xl',
  order: '/admin/country/display-order'
};

export const history = {
  histories: '/admin/breast-pump/history',
  historyDetail: '/admin/breast-pump/history/detail',
  xl: '/admin/breast-pump/history/xl',
  xlDetail: '/admin/breast-pump/history/xl/detail',
};

export const breastPump = {
  breastPumpList: '/admin/breast-pump',
  verifyLogList: '/admin/breast-pump/verify',
  xl: '/admin/breast-pump/xl',
  verifyXl: '/admin/breast-pump/verify/xl/detail',
  deleteBreast: '/admin/breast-pump/',
  xlUpload: '/admin/breast-pump/upload',
  canReset: '/admin/breast-pump/reset/',
  resetBreastPump: '/admin/breast-pump/reset/',
  resetUser: '/admin/breast-pump/user/',
  userBreastPumpList: '/admin/breast-pump/user/',
}

export const banner = {
  getAllBanners: '/admin/banner/',
  upsertBanner: '/admin/banner',
  deleteBanner: '/admin/banner/'
};

export const push = {
  upsertPush: '/admin/push',
  getAllPushes: '/admin/push',
  getPush: '/admin/push/',
  deletePush: '/admin/push/',
  sendPush: '/admin/push/send/',
  xl: '/admin/push/xl'
};

export const inquiry = {
  getAllInquiry: '/admin/inquiry',
  // HTTP METHOD: GET
  // PARAMETERS: InquiryParameter,
  getInquiry: '/admin/inquiry/',
  // HTTP METHOD: GET
  // PARAMETERS: Long,
  answerPath : (inquiryNo) => `/admin/inquiry/${inquiryNo}/answer`,
  // HTTP METHOD: POST
  // PARAMETERS: SaveAnswerRequest,
  xl: '/admin/inquiry/xl',
  adminRead: '/admin/inquiry/read'
};

export const user = {
  join: '/admin/user/join',
  // HTTP METHOD : POST
  // PARAMETERS : UserJoinRequest, HttpServletResponse,
  logOut: '/admin/user/log/out',
  // HTTP METHOD : POST
  // PARAMETERS : UserLogOutRequest, HttpServletResponse,
  getUser: '/admin/user/information',
  // HTTP METHOD : GET
  // PARAMETERS : Principal,
  renewDeviceInfo: '/admin/user/renew/device-info',
  // HTTP METHOD : PATCH
  // PARAMETERS : UserRenewDeviceInfoRequest,
  logIn: '/admin/user/log/in',
  // HTTP METHOD : PATCH
  // PARAMETERS : UserLogInRequest, HttpServletResponse,
  userDetail : '/admin/user/',
  loginLog : '/admin/user/log',
  lock: '/admin/user/lock/',
  userList: '/admin/user',
  xl: '/admin/user/xl',
  xlWithdraw: '/admin/user/xl/withdraw',
  xlLog: '/admin/user/xl/log',
  changeStatus: '/admin/user/status/',
};

//Project Name : null//Created at 2023-12-01 04:08:30